<!-- =========================================================================================
  File Name: ClientEdit.vue
  Description: Client Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: iTOVi - Admin
========================================================================================== -->

<template>
  <div id="main-container">
    <vx-card>
      <h4 class="mb-4">Client Edit</h4>

      <div class="vx-row">

        <!-- left column -->
        <div class="vx-col w-1/2">
          <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
              <vs-input class="w-full"
                        label-placeholder="First Name"
                        type="text"
                        v-model="client.first_name"/>
            </div>
            <div class="vx-col w-1/2">
              <vs-input class="w-full"
                        label-placeholder="Last Name"
                        type="text"
                        v-model="client.last_name"/>
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-input class="w-full"
                        label-placeholder="Email"
                        type="text"
                        v-model="client.email"/>
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-input class="w-full"
                        label-placeholder="Phone"
                        type="text"
                        v-model="client.phone"/>
            </div>
          </div>
        </div>


        <!-- right column-->
        <div class="vx-col w-1/2">

        </div>

      </div>

      <vs-row class="mt-4">
        <vs-button class="mx-1" @click="saveChanges">SAVE CHANGES</vs-button>
      </vs-row>
    </vx-card>

  </div>
</template>

<script>
  import api from '@/http/api';
  import types from '@/models';
  import jsonHtml from '@/misc/jsonHtmlPrinter'

  import helpers from '@/models/helpers';

  export default {
    components: {

    },
    mounted() {
      this.fetchClient();
    },
    data() {
      return {
        jsonHtml: jsonHtml,
        unsavedChanges: {},
        types: types,
        isLoading: false,
        client: new types.Client(),
        helpers: helpers,
        showForgetButton: false,
        isMeClient: false,
      }
    },
    computed: {
      clientId() {
        return this.$route.query.id || null;
      },
      howManyUnsavedChanges() {
        let count = 0;
        let keys = Object.keys(this.unsavedChanges);
        for (let i = 0; i < keys.length; i++) {
          if (this.unsavedChanges[keys[i]]) {
            count++;
          }
        }
        return count;
      },
    },
    watch: {
      isLoading(oldVal, newVal) {
        if (!newVal) {
          this.$vs.loading();
        } else {
          this.$vs.loading.close();
        }
      }
    },
    methods: {
      showNotification(success, message) {
        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: message ? message : '',
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'});
      },
      async fetchClient() {
        let client = await api.fetchClient(this.clientId);
        if (client === null) {
          // todo: handle error
        }

        this.client = client;

        this.isMeClient = this.client.client_id === this.client.user.client_id;
      },
      async saveChanges() {
        let data = {
          first_name: this.client.first_name,
          last_name: this.client.last_name,
          email: this.client.email,
          phone: this.client.phone,
        };

        let client = await api.updateClient(this.clientId, data);

        if (client === null) {
          this.showNotification(false, 'Could not save changes');
          return;
        }

        this.$router.push(`/clients/detail?id=${this.clientId}`).catch(()=> {});
      }
    },
    beforeRouteLeave(to, from, next) {
      if (this.howManyUnsavedChanges <= 0) {
        next();
      } else {
        // next(false);
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirm`,
          text: 'Are you sure you want to leave this page? You will lose your unsaved changes.',
          accept: () => {
            next()
          }
        });
      }
    },
  }

</script>


<style lang="scss">
  #main-container {

    .algolia-header {
      .algolia-filters-label {
        width: calc(260px + 2.4rem);
      }
    }

    #algolia-content-container {

      .vs-sidebar {
        position: relative;
        float: left;
      }
    }

    .algolia-search-input-right-aligned-icon {
      padding: 1rem 1.5rem;
    }

    .algolia-price-slider {
      min-width: unset;
    }

    .item-view-primary-action-btn {
      color: #2c2c2c !important;
      background-color: #f6f6f6;
      min-width: 50%;
    }

    .item-view-secondary-action-btn {
      min-width: 50%;
    }
  }

  .theme-dark {
    #main-container {
      #algolia-content-container {
        .vs-sidebar {
          background-color: #10163a;
        }
      }
    }
  }

  @media (min-width: 992px) {
    .vs-sidebar-rounded {
      .vs-sidebar {
        border-radius: .5rem;
      }

      .vs-sidebar--items {
        border-radius: .5rem;
      }
    }
  }

  @media (max-width: 992px) {
    #algolia-content-container {
      .vs-sidebar {
        position: absolute !important;
        float: none !important;
      }
    }
  }

</style>

